/* L&S: Fester Kaufbutton. Spiegelt Preis und Zustand des Haupt-Kaufbuttons und löst ihn aus. */
if (!customElements.get('ls-sticky-atc')) {
  customElements.define(
    'ls-sticky-atc',
    class LsStickyAtc extends HTMLElement {
      connectedCallback() {
        this.mainButton = document.querySelector('[id^="ProductSubmitButton-"][id$="__main"]');
        if (!this.mainButton) return;

        this.mainPrice = document.querySelector('[id^="price-"][id$="__main"]');
        this.button = this.querySelector('[data-ls-sticky-button]');
        this.label = this.querySelector('[data-ls-sticky-label]');
        this.price = this.querySelector('[data-ls-sticky-price]');
        this.defaultLabel = this.button.dataset.label;

        this.button.addEventListener('click', () => {
          if (!this.mainButton.disabled) this.mainButton.click();
        });

        this.syncPrice();
        this.syncButton();
        this.observeMain();
        this.observeVisibility();
        this.hidden = false;
      }

      disconnectedCallback() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        document.body.classList.remove('ls-sticky-atc-visible');
      }

      syncPrice() {
        if (!this.price || !this.mainPrice) return;
        const source = this.mainPrice.querySelector('.price');
        this.price.innerHTML = source ? source.outerHTML : '';
      }

      syncButton() {
        const disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        const mainLabel = this.mainButton.querySelector('span')?.textContent.trim();
        this.button.disabled = disabled;
        this.label.textContent = disabled && mainLabel ? mainLabel : this.defaultLabel || mainLabel;
      }

      observeMain() {
        this.mutationObserver = new MutationObserver(() => {
          this.syncPrice();
          this.syncButton();
        });
        const options = { childList: true, subtree: true, characterData: true, attributes: true };
        this.mutationObserver.observe(this.mainButton, options);
        if (this.mainPrice) this.mutationObserver.observe(this.mainPrice, { childList: true, subtree: true });
      }

      observeVisibility() {
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.toggleAttribute('data-visible', scrolledPast);
          this.setAttribute('aria-hidden', String(!scrolledPast));
          this.button.tabIndex = scrolledPast ? 0 : -1;
          document.body.classList.toggle('ls-sticky-atc-visible', scrolledPast);
        });
        this.intersectionObserver.observe(this.mainButton);
      }
    }
  );
}
